const getByPath = (obj, path) => {
  if (!path || !obj) return undefined;
  return String(path)
    .split(".")
    .reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
};

const normalizeComparable = (value) => {
  if (typeof value === "string") return value.toLowerCase();
  return value;
};

const evaluateSingleRule = (rule, context) => {
  if (!rule) return true;

  const when = rule.when ?? rule;

  if (when === "always") return true;
  if (when === "never") return false;

  if (when === "and" && Array.isArray(rule.rules)) {
    return rule.rules.every((r) => evaluateRule(r, context));
  }
  if (when === "or" && Array.isArray(rule.rules)) {
    return rule.rules.some((r) => evaluateRule(r, context));
  }
  if (when === "not" && rule.rule) {
    return !evaluateRule(rule.rule, context);
  }

  const left = getByPath(context, rule.path);
  const right = rule.value;

  switch (when) {
    case "equals":
      if (typeof left === "string" || typeof right === "string") {
        return normalizeComparable(left) === normalizeComparable(right);
      }
      return left === right;
    case "notEquals":
      if (typeof left === "string" || typeof right === "string") {
        return normalizeComparable(left) !== normalizeComparable(right);
      }
      return left !== right;
    case "in":
      return Array.isArray(right) && right.map(normalizeComparable).includes(normalizeComparable(left));
    case "notIn":
      return Array.isArray(right) && !right.map(normalizeComparable).includes(normalizeComparable(left));
    case "empty":
      return (
        left == null ||
        left === "" ||
        (Array.isArray(left) && left.length === 0) ||
        (typeof left === "object" && !Array.isArray(left) && Object.keys(left).length === 0)
      );
    case "notEmpty":
      return !evaluateSingleRule({ when: "empty", path: rule.path }, context);
    default:
      return true;
  }
};

export const evaluateRule = (rule, context) => {
  if (!rule) return true;
  if (rule.when === "always") return true;
  if (rule.when === "never") return false;
  return evaluateSingleRule(rule, context);
};

export const buildRuleContext = ({
  patient = {},
  permissions = {},
  appointment = {},
  doctor = {},
  stores = {},
  row = {},
} = {}) => ({
  context: { patient, permissions, appointment, doctor },
  stores,
  row,
});

export { getByPath };
